import SearchPickEmployeePresenter from "./SearchSelectUserPresenter";

export const SearchPickEmployee = SearchPickEmployeePresenter;

export default SearchPickEmployee;